/* eslint-disable */
// This file is generated by scripts/codegen/grammars.ts. Do not edit.

import type { LazyLang } from "./types.ts";

export type { LazyLang };

import type { Language } from "@/utils/textmate/language";

// enum cast, the values are only ever generated from the same enum
export const languagesWithGrammars: Set<Language> = new Set(["source.json","source.js","source.ts","source.tsx","source.jsx","source.html","source.css"] as Language[]);
export function json(): Promise<LazyLang> { return import("./json.ts").then(({default: d}) => d); }
export function js(): Promise<LazyLang> { return import("./js.ts").then(({default: d}) => d); }
export function ts(): Promise<LazyLang> { return import("./ts.ts").then(({default: d}) => d); }
export function tsx(): Promise<LazyLang> { return import("./tsx.ts").then(({default: d}) => d); }
export function jsx(): Promise<LazyLang> { return import("./jsx.ts").then(({default: d}) => d); }
export function html(): Promise<LazyLang> { return import("./html.ts").then(({default: d}) => d); }
export function css(): Promise<LazyLang> { return import("./css.ts").then(({default: d}) => d); }
